<template>
    <div class="welcome">
        <div v-if="phone" class="main_header">
            <router-link class="home-logo" to="home-page">
                <img src="../assets/logo_second.png" alt="">
            </router-link>
            <router-link class="home-link" to="home-page">
                <span v-if="lang">主页</span>
                <span v-else class="english">HOME</span>
            </router-link>
            <router-link class="home-link" to="ayo-about">
                <img id="ayo_icon" class="ayo_icon" src="../assets/ayo.png" alt="">
                <img id="ayo_icon_2" class="ayo_icon" src="../assets/ayo_2.png" alt="">
            </router-link>
            <router-link class="home-link" to="afsc-about">
                <img id="afsc_icon" class="afsc_icon" src="../assets/afsc_icon_2.png" alt="">
                <img id="afsc_icon_2" class="afsc_icon" src="../assets/afsc_icon_4.png" alt="">
            </router-link>
            <router-link class="home-link" to="company-profile">
                <span v-if="lang">关于我们</span>
                <span v-else class="english">ABOUT US</span>
            </router-link>
            <span class="home-link" v-on:click="btn_change()">
        <span v-if="lang">
          <img src="../assets/China.jpg" class="jack" alt=""><span class="english lang_color"> CN</span> / <img
                src="../assets/Usa.jpg" class="jack" alt=""><span class="english"> US</span>
        </span>
        <span v-else>
          <img src="../assets/China.jpg" class="jack" alt=""><span class="english"> CN</span> / <img
                src="../assets/Usa.jpg" class="jack" alt=""><span class="english lang_color"> US</span>
        </span>
      </span>
        </div>
        <div v-else class="phone_bar" @click="Allfoothide()">
            <div v-show="phone_show" class="phone_main_title"></div>
            <div v-show="phone_show" class="phone_main_logo">
                <div class="home-logo">
                    <img src="../assets/logo_second.png" alt=""/>
                </div>
                <div class="">
                    <router-link class="home-link" to="home-page">
                        <span v-if="lang" @click="phoneshow()">主页</span>
                        <span v-else class="english" @click="phoneshow()">HOME</span>
                    </router-link>
                </div>
                <div>
                    <router-link class="home-link" to="ayo-about">
                        <img @click="phoneshow()" id="phoneayo_icon" class="ayo_icon" src="../assets/ayo.png" alt="">
                        <img @click="phoneshow()" id="phoneayo_icon_2" class="ayo_icon" src="../assets/ayo_2.png"
                             alt="">
                    </router-link>
                </div>
                <div>
                    <router-link class="home-link" to="afsc-about">
                        <img @click="phoneshow()" id="phoneafsc_icon" class="afsc_icon" src="../assets/afsc_icon_2.png"
                             alt="">
                        <img @click="phoneshow()" id="phoneafsc_icon_2" class="afsc_icon"
                             src="../assets/afsc_icon_4.png" alt="">
                    </router-link>
                </div>
                <div>
                    <router-link class="home-link" to="company-profile">
                        <span @click="phoneshow()" v-if="lang">关于我们</span>
                        <span @click="phoneshow()" v-else class="english">ABOUT US</span>
                    </router-link>
                </div>
                <div class="home-link" @click.stop="footShow()">
                    <span v-if="lang">联系我们</span>
                    <span v-else class="english">CONTACT US</span>
                </div>
                <div class="home-link" v-on:click="btn_change()">
    			<span v-if="lang">
          	<img src="../assets/China.jpg" class="jack" alt=""><span class="english lang_color"> CN</span><br/><img
                        src="../assets/Usa.jpg" class="jack" alt=""><span class="english"> US</span>
	        </span>
                    <span v-else>
	          <img src="../assets/China.jpg" class="jack" alt=""><span class="english"> CN</span><br/><img
                            src="../assets/Usa.jpg" class="jack" alt=""><span class="english lang_color"> US</span>
	        </span>
                </div>
                <div></div>
            </div>

            <div class="phone_header">
                <img src="../assets/main_click_1.png" v-show="img_show" @click.stop="phoneshow()" alt=""/>
                <img src="../assets/main_click_2.png" v-show="!img_show" @click.stop="phoneshow()" alt=""/>
            </div>
            <transition name="mybox">
                <div @click.stop="hehe()" v-show="foot_show" class="phone_foot">
                    <div class="foot_x" @click.stop="foot_hide()">x</div>
                    <div class="foot_phone_title">
                        <span v-if="lang">联系我们</span><span v-else class="english">Contact us</span>
                    </div>
                    <div class="foot_phone_0">
                        <span v-if="lang">邮箱：</span><span v-else class="english">email: </span><span class="english">fxh@fangxuehai.cc</span>
                    </div>
                    <div class="foot_phone_1">
                        <span v-if="lang">地址：上海市 杨浦区 军工路 100号 18栋 放学嗨</span>
                        <span v-else class="english">address: Afterschool, Building 18，No. 100, Jungong Road, Yangpu District, Shanghai</span>
                    </div>
                    <div v-on:click="link_to()" class="foot_phone_2">
                        <img src="../assets/sina_logo.png" alt="">
                        <span v-if="lang"> 放学嗨</span>
                        <span v-else class="english"> Afterschool</span>
                    </div>
                    <div class="foot_phone_3">
                        <div>
                            <p><img src="../assets/wx_fxh.jpg" alt=""></p>
                            <p><img src="../assets/wx_logo.png" alt=""><span v-if="lang"> 放学嗨</span>
                                <span v-else class="english"> Afterschool</span></p>
                        </div>
                        <div>
                            <p><img src="../assets/wx_afsc.jpg" alt=""></p>
                            <p><img src="../assets/wx_logo.png" alt=""><span class="english"> AFSC</span></p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <router-view :lang="lang"></router-view>
    </div>
</template>
<script>

    export default {
        name: 'HelloWorld',
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                phone: true,
                lang: false,
                phone_show: false,
                foot_show: false,
                img_show: true,
                country:'',
            }
        },

        mounted() {
            var that = this;
            $.ajax({
                url: 'http://cp.wxmolegames.com/ipinfo.php',
                method: 'GET',
                dateType: 'JSON',
                success: function (result) {
                    console.log(result);
                    that.country = result;
                    if (result == '中国') {
                        that.lang = true;
                    } else {
                        that.lang = false;
                    }
                    console.log(that.lang);
                    if (that.lang == false) {
                        document.title = "After School Official | Explore new ways of life with playful attitude"
                    } else {
                        document.title = "放学嗨 | 用玩的态度探索全新生活方式"
                    }
                }

            })

            this.phone = this.IsPC()
        },

        methods: {
            btn_change() {
                this.lang = !this.lang;
                console.log(this.lang);
                if (this.lang == false) {
                    document.title = "After School Official | Explore new ways of life with playful attitude";
                    if (this.country == '中国'){
                        alert('大陆地区不支持英文版网页的YouTube访问');
                    }
                } else {
                    document.title = "放学嗨 | 用玩的态度探索全新生活方式"
                }
                this.phone_show = !this.phone_show;
            },
            phoneshow() {
                this.phone_show = !this.phone_show;
                this.img_show = !this.img_show
            },
            link_to() {
                window.location.href = "https://weibo.com/u/5692890069?refer_flag=1001030101_&is_hot=1"
            },
            IsPC() {
                var userAgentInfo = navigator.userAgent;
                var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone", "iPod"];
                var flag = true;
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            },
            footShow() {
                this.foot_show = !this.foot_show;
            },
            foot_hide() {
                this.foot_show = !this.foot_show;
            },
            Allfoothide() {
                this.phone_show = false;
                this.img_show = true
            },
            hehe() {

            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .main_header {
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 100;
        color: #FFFFFF;
        height: 100px;
        line-height: 100px;
        min-width: 980px;
        font-weight: bold;
        .home-logo {
            margin-right: 42%;
            padding-top: 10px;
            img {
                vertical-align: middle;
                width: 60px;
            }
        }
        .home-link {
            color: #FFFFFF;
            text-decoration: none;
            font-size: 12px;
            margin-left: 20px;
            &:hover {
                cursor: pointer;
            }
        }
        .router-link-active {
            color: #F2F00D;
        }
    }

    .jack {
        position: relative;
        top: 0.5px;
        width: 15px;
    }

    .ayo_icon {
        position: relative;
        top: 8px;
        width: 27px;
    }

    .afsc_icon {
        width: 30px;
    }

    .lang_color {
        color: #F2F00D;
    }

    #afsc_icon_2 {
        display: none;
    }

    #ayo_icon_2 {
        display: none
    }

    #phoneayo_icon_2 {
        display: none;
    }

    #phoneafsc_icon_2 {
        display: none;
    }

    .phone_bar {
        width: 100%;
    }

    .phone_header {
        width: 10%;
        position: absolute;
        z-index: 100;
        top: 2rem;
        left: 2rem;
        img {
            width: 100%;
            transition: all 2s ease;
        }
        transition: all 1s ease;
    }

    .phone_main_title {
        position: fixed;
        top: 0;
        left: 0;
        background-color: #000000;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        z-index: 100;
    }

    .phone_main_logo {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        padding-top: 1rem;
        .home-logo {
            margin: 0 auto;
            width: auto;
            margin-bottom: 3rem;
        }
        .home-link {
            color: #FFFFFF;
            text-decoration: none;
            font-size: 2rem;
            font-family: Heavy;
            font-weight: bold;
            margin-bottom: 2rem;
            &:hover {
                cursor: pointer;
            }
            img {
                width: 5rem;
            }
            .ayo_icon {
                width: 4rem;
            }
            .jack {
                width: 8%;
            }
        }
        .router-link-active {
            color: #F2F00D;
        }
    }

    .mybox-leave-active, .mybox-enter-active {
        transition: all 1s ease;
    }

    .mybox-leave-active, .mybox-enter {
        height: 0px !important;
    }

    .mybox-leave, .mybox-enter-active {
        height: 25rem;
    }

    .phone_foot {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 25rem;
        background-color: #FFFB00;
        z-index: 101;
    }

    .foot_phone_title {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
        font-size: 2.6rem;
        font-weight: bold;
        color: #000000;
        font-family: Heavy;
    }

    .foot_phone_1, .foot_phone_0 {

        font-family: Heavy;
        margin-top: .5rem;
        margin-bottom: .5rem;
        font-weight: bold;
        color: #000000;
    }

    .foot_phone_2 {
        span {
            display: inline-block;
            padding-top: 0.15rem;
            font-family: Heavy;
            vertical-align: top;
            font-weight: bold;
            color: #000000;
        }
    }

    .foot_phone_3 {
        display: flex;
        justify-content: center;
        & > div:first-child {
            margin-right: 3rem;
        }
        span {
            color: #000000;
            display: inline-block;
            font-family: Heavy;
            vertical-align: top;
            font-weight: bold;
            font-size: 1.1rem;
        }
    }

    .foot_x {
        position: absolute;
        font-size: 2rem;
        right: 1.5rem;
        top: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue